import Marquee from "react-fast-marquee"
import { motion, useAnimation, useInView } from "framer-motion";
import Image from "next/image";

function Services({services})
{
    const firstRowServices = services.slice(0, Math.ceil(services.length / 2));
    const secondRowServices = services.slice(Math.ceil(services.length / 2));
    return <div id="services" className="flex flex-wrap items-center justify-between relative bottom-[200px]">
        <p className="text-left text-greyTitleBase900 font-noto-sans  text-[32px] font-[600] px-[24px] ">Hiring across 5,000+ roles, including</p>
        <Marquee speed={100}>
            <div className="flex flex-wrap w-full">
            {firstRowServices.map((item, index) => {
								return  <motion.div	

									transition={{ duration: 0.2, delay: 0.2 }}
									initial={"hidden"}
                                    animate={"control"}
                                    className="flex gap-x-[8px]"
									key={`item-${index + 1}`}>
                                        <div id="role" className="ml-[10px] w-[40%]">
                                        <Image src={item.image.src} alt={item?.name} width={141} height={141} className="rounded-[23px]"/>
                                        <p className="flex flex-wrap text-[16px] font-noto-sansNormal text-greyTertiaryBase500 mt-[12px]">{item.name}</p>

                                        </div>
									
								</motion.div>
 							} )}
            

            </div>
        </Marquee>
        <Marquee speed={100}>
            <div className="flex flex-wrap w-full mt-[32px]">
            {secondRowServices.map((item, index) => {
								return  <motion.div	

									transition={{ duration: 0.2, delay: 0.2 }}
									initial={"hidden"}
                                    animate={"control"}
                                    className="flex gap-x-[8px]"
									key={`item-${index + 1}`}>
                                        <div id="role" className="ml-[10px] w-[40%]">
                                        <Image src={item.image.src} width={141} height={141} alt={item?.name} className="rounded-[23px]"/>
                                        <p className="flex flex-wrap font-noto-sansNormal text-greyTertiaryBase500 mt-[12px]">{item.name}</p>

                                        </div>
									
								</motion.div>
 							} )}
            

            </div>
        </Marquee>

    </div>

}
export default Services;